export const testimonials = [
  {
    id: 't1',
    name: '娱乐圈老司机',
    role: '资深吃瓜群众 · 3年用户',
    quote: '自从发现了吃瓜网，我再也不用在各个平台来回切换了。这里的瓜不仅全，而且更新速度飞快，好几次我都是在这里先看到的爆料，然后才在其他平台发酵。真正的一手瓜源地！',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Chinese%20man%20in%20stylish%20casual%20outfit%2C%20neutral%20warm%20gray%20background%2C%20soft%20studio%20lighting%2C%20friendly%20expression%2C%20clean%20minimal%20look%2C%20professional%20headshot%20style&width=200&height=200&seq=testimonial-avatar-01&orientation=squarish',
  },
  {
    id: 't2',
    name: '八卦小能手',
    role: '微博大V · 1年用户',
    quote: '作为经常需要找素材的内容创作者，吃瓜网简直是我的宝藏。分类清晰、更新及时，而且很多独家内容在别的地方根本看不到。已经推荐给了身边所有爱吃瓜的朋友！',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Chinese%20woman%20with%20modern%20hairstyle%2C%20warm%20beige%20background%2C%20soft%20natural%20lighting%2C%20confident%20smile%2C%20editorial%20portrait%20style%2C%20clean%20composition&width=200&height=200&seq=testimonial-avatar-02&orientation=squarish',
  },
  {
    id: 't3',
    name: '深夜吃瓜人',
    role: '忠实粉丝 · 2年用户',
    quote: '每天睡前的必修课就是刷一遍吃瓜网，看看今天又有谁塌房了。网站的界面很干净，没有乱七八糟的广告，阅读体验特别好。凌晨更新的习惯和我这个夜猫子简直是绝配！',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20young%20adult%20with%20trendy%20glasses%2C%20warm%20cream%20background%2C%20soft%20studio%20lighting%2C%20intellectual%20vibe%2C%20clean%20modern%20headshot%2C%20friendly%20expression&width=200&height=200&seq=testimonial-avatar-03&orientation=squarish',
  },
];

export const brandStats = [
  { label: '日均访问量', value: '128万+' },
  { label: '独家爆料', value: '3,200+' },
  { label: '活跃用户', value: '86万+' },
  { label: '更新速度', value: '10分钟' },
];